import { Database, Package } from 'lucide-react'

import { cn } from '@/lib/cn'
import { Spinner } from '@/components/ui/misc'
import type { Bucket } from '@/lib/api'

export function BucketSidebar({
  buckets,
  loading,
  selected,
  onSelect,
}: {
  buckets: Bucket[]
  loading: boolean
  selected: string | null
  onSelect: (bucket: string) => void
}) {
  return (
    <aside className="flex w-56 shrink-0 flex-col border-r border-border bg-surface">
      <div className="flex items-center gap-2 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <Database className="h-3.5 w-3.5" />
        Buckets
      </div>

      <nav className="flex-1 space-y-0.5 overflow-y-auto px-2 pb-3">
        {loading && (
          <div className="px-2 py-2">
            <Spinner />
          </div>
        )}

        {!loading &&
          buckets.map((bucket) => (
            <button
              key={bucket.name}
              onClick={() => onSelect(bucket.name)}
              className={cn(
                'flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-left text-sm transition-colors',
                bucket.name === selected
                  ? 'bg-accent/12 font-medium text-accent'
                  : 'hover:bg-muted',
              )}
              aria-current={bucket.name === selected ? 'true' : undefined}
            >
              <Package className="h-4 w-4 shrink-0" />
              <span className="truncate">{bucket.name}</span>
            </button>
          ))}
      </nav>

      {/* The allow-list is a deliberate safety boundary, so it is worth saying
          out loud rather than leaving the list looking incomplete. */}
      <p className="border-t border-border px-4 py-3 text-xs text-muted-foreground">
        Only buckets configured for this app are shown.
      </p>
    </aside>
  )
}
